export default __webpack_public_path__ + "f3d8e0795db186708dab8ba78fdb5c1b.png";